import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_APIURL,
    withCredentials: true  // 쿠키 자동 포함
});

// 요청 인터셉터 - Authorization 헤더 설정 제거
api.interceptors.request.use(
    (config) => {
        // 쿠키가 자동으로 포함되므로 별도 설정 불필요
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// ***** 이 부분을 아래 코드로 교체해야 합니다 *****
api.interceptors.response.use(
    (response) => {
        // 성공적인 응답은 그대로 반환
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        
        // ✅ refresh API는 인터셉터 로직을 건너뛰기
        if (originalRequest.url?.includes('users/token/refresh/')) {
            return Promise.reject(error);
        }
        
        // 1. access_token 만료로 인한 401 에러이고,
        // 2. 재시도한 요청이 아닐 경우 (무한 루프 방지)
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true; // 재시도 플래그 설정

            try {
                // 3. 토큰 갱신 API 호출 (이 부분이 핵심!)
                await api.post('users/token/refresh/');
                
                // 4. 원래 요청을 다시 시도
                // (새로운 access_token은 쿠키에 자동 설정되었으므로 그냥 재요청)
                return api(originalRequest);

            } catch (refreshError) {
                // 5. refresh_token마저 만료되어 갱신에 실패한 경우
                console.error('Session expired. Redirecting to login.');
                // 여기서 로그아웃 처리 또는 로그인 페이지로 리다이렉트
                window.location.href = process.env.REACT_APP_REDIRECT_URI;
                return Promise.reject(refreshError);
            }
        }

        // 그 외 다른 에러는 그대로 반환
        return Promise.reject(error);
    }
);

export default api;